import { BadgeCheck } from "lucide-react";
import { VERIFICATION_LABELS } from "@/lib/constants";

export const VerificationBadges = ({ verifications, compact }) => {
  const active = Object.entries(verifications || {}).filter(([, v]) => v);
  if (!active.length)
    return <p className="text-sm text-muted-foreground">Henüz doğrulama yapılmamış</p>;
  return (
    <div className="flex flex-wrap gap-2" data-testid="verification-badges">
      {active.map(([key]) => (
        <span
          key={key}
          data-testid={`badge-${key}`}
          className="inline-flex items-center gap-1.5 rounded-full border border-accent bg-accent/15 px-3 py-1 text-xs font-semibold text-primary"
        >
          <BadgeCheck className="h-4 w-4 text-accent" />
          {compact ? VERIFICATION_LABELS[key].split(" ")[0] : VERIFICATION_LABELS[key]}
        </span>
      ))}
    </div>
  );
};

export const VerificationNote = () => (
  <p className="text-xs leading-relaxed text-muted-foreground">
    Doğrulama rozetleri Ciftora'nın kendi kontrolleri sonucu verilir. Resmî kurum doğrulaması
    değildir.
  </p>
);
